import {Component, OnDestroy, OnInit} from '@angular/core';
import {Action} from '@app/components/shared/table/model/action';
import {Table} from '@app/components/shared/table/model/table';
import {Race} from '@app/rest-client/faxe/models/race';
import {RaceFacadeService} from '@app/facade-services/race/race-facade.service';
import {mapRaces} from '@app/components/admin/race/mapper/race-mapper-service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {DialogId} from '@app/constants/dialog-id';
import { MatCard } from '@angular/material/card';
import { TableComponent } from '@app/components/shared/table/table.component';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'faxe-admin-race',
  templateUrl: './admin-race.component.html',
  styleUrls: ['./admin-race.component.scss'],
  imports: [
    MatCard,
    TableComponent,
    MatButton
  ]
})
export class AdminRaceComponent implements OnInit, OnDestroy {

  tableData: Table<Race>;
  private unsubscribe$ = new Subject<void>();

  constructor(private readonly raceFacadeService: RaceFacadeService,
              private activatedRoute: ActivatedRoute,
              private router: Router,) {
  }

  inlineEditAction($event: Action<any>) {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {

    this.raceFacadeService.fetchRace('AdminRaceComponent')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(races => {
        this.tableData = mapRaces(races);
      });
  }

  onAdd() {
    this.navigate();
  }

  private navigate(): void {
    const navigationExtras: NavigationExtras = {
      relativeTo: this.activatedRoute,
      queryParams: {
      },
    };

    this.router.navigate([{outlets: {dialog: [DialogId.createRace]}}],
      navigationExtras
    );
  }

}
